import { useRouter } from "next/router";
import { useCallback } from "react";

import { FILTER_CATEGORIES } from "@chef/constants";

export const useFilters = () => {
  const router = useRouter();

  const replace = (f: string, p = window.location.pathname) => {
    router.replace(
      {
        pathname: p,
        query: { ...router.query, filter: f },
      },
      {
        pathname: p,
        query: { filter: f },
      },
      { scroll: false, shallow: true },
    );
  };

  const updateUrl = useCallback(
    (value: string) => {
      const _value = value.toLowerCase();

      if (
        _value === FILTER_CATEGORIES.ALL_CATEGORIES_SLUG ||
        _value === router.query["filter"]
      ) {
        replace(FILTER_CATEGORIES.ALL_CATEGORIES_SLUG);
      } else {
        replace(_value);
      }
    },
    [router],
  );

  return { updateUrl };
};
